'use client'

/**
 * Next.js adapter for shared form components.
 *
 * Re-exports framework-specific primitives so shared components don't import
 * `next/link` directly. Phase 1A creates the boundary; Phase 1B adds a Start
 * adapter and makes the import path injectable.
 */
export { default as Link } from 'next/link'
